import { flexRowCenter } from '../../../../common/styles/flex';
import { PlayerSizesTypes } from '../../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { CTA_BUTTON_MARGIN_RIGHT } from '../../controlsPlugin.constants';

interface StylesObject {
  titleAndLogoStyle: { [key: string]: any };
  shareIconStyle: { [key: string]: any };
}

const getTitleAndLogoStyle = (ctaButtonWidth: number, playerSize: PlayerSizesTypes) => {
  const style = [];
  style.push( {
    ...flexRowCenter,
    alignItems: 'center',
    width: '100%',
    marginRight: `${ctaButtonWidth !== 0 ? ctaButtonWidth + CTA_BUTTON_MARGIN_RIGHT.MEDIUM : 0}px`,
  });
  switch (playerSize) {
    case 'large':
      style.push({
        marginRight: `${ctaButtonWidth !== 0 ? ctaButtonWidth + CTA_BUTTON_MARGIN_RIGHT.LARGE : 0}px`,
      });
      break;
    case 'extraLarge':
      style.push({
        marginRight: `${ctaButtonWidth !== 0 ? ctaButtonWidth + CTA_BUTTON_MARGIN_RIGHT.EXTRA_LARGE : 0}px`,
      });
      break;
    default:
      break;
  }
  return style;
};

const getShareIconStyle = (playerSize, shareHovered) => {
  const style = [];
  style.push({
    color: SITE_VARIABLES.COLORS.WHITE,
    cursor: 'pointer',
    opacity: '0.7',
    display: 'flex',
  });
  if (shareHovered) {
    style.push({ opacity: '1' });
  }

  switch (playerSize) {
    case 'small':
      style.push({
        display: 'none',
      });
      break;
    case 'medium':
      style.push({
        display: 'none',
      });
      break;
    case 'large':
      style.push({
        height: '16px',
        width: '16px',
        minWidth: '16px',
        marginRight: '8px',
      });
      break;
    case 'extraLarge':
      style.push({
        height: '20px',
        width: '20px',
        minWidth: '20px',
        marginRight: '16px',
      });
      break;
    default:
      break;
  }
  return style;
};

export const getLogoAndTitleStyleObject = (showLogo: boolean, playerSize: PlayerSizesTypes, ctaButtonWidth: number, shareHovered?: boolean): StylesObject => {
  return ({
    titleAndLogoStyle: [
      getTitleAndLogoStyle(ctaButtonWidth, playerSize),
    ],
    shareIconStyle: [
      getShareIconStyle(playerSize, shareHovered),
    ],
  });
};
